/**
 * 文字列の表記ゆれをなくすための正規化関数
 * - 前後および連続する空白の削除/統一
 * - 全角英数字の半角化
 * - 全て小文字に変換
 */
export function normalizeString(str: string | undefined | null): string {
  if (!str) return '';

  // 1. 全角英数字を半角に変換
  let normalized = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });

  // 2. 小文字化
  normalized = normalized.toLowerCase();

  // 3. 前後の空白削除と、連続する空白（全角スペース含む）を1つの半角スペースに統一
  normalized = normalized.replace(/[\s　]+/g, ' ').trim();

  return normalized;
}

/**
 * 文字列の各単語の先頭を大文字にする（Title Case）
 * 例: "double apple" -> "Double Apple"
 */
export function toTitleCase(str: string | undefined | null): string {
  if (!str) return '';
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
}
